// =============================================================================
// Result Step — outcome finale (auto / approval)
// =============================================================================

import { useTranslation } from 'react-i18next';
import { CheckCircle2, ClockIcon } from 'lucide-react';
import type { SubmitBookingResult } from '../../api/public-booking-hooks';
import { PrimaryButton } from './PrimaryButton';

interface Props {
  result: SubmitBookingResult;
  onAgain: () => void;
}

export function ResultStep({ result, onAgain }: Props) {
  const { t } = useTranslation('public-booking');

  const isAuto = result.outcome === 'auto';
  const Icon = isAuto ? CheckCircle2 : ClockIcon;
  const colorClass = isAuto ? 'text-emerald-600 bg-emerald-50' : 'text-amber-600 bg-amber-50';

  return (
    <div className="text-center py-8 space-y-4">
      <div className={`mx-auto w-16 h-16 rounded-full flex items-center justify-center ${colorClass}`}>
        <Icon className="w-9 h-9" />
      </div>
      <h2 className="text-xl font-semibold text-gray-900">
        {isAuto ? t('result.autoTitle') : t('result.approvalTitle')}
      </h2>
      <p className="text-sm text-gray-600 max-w-md mx-auto">
        {isAuto ? t('result.autoBody') : t('result.approvalBody')}
      </p>
      <div className="pt-4">
        <PrimaryButton onClick={onAgain}>{t('actions.newBooking')}</PrimaryButton>
      </div>
    </div>
  );
}
